import React from 'react';

import { SVG } from 'types/svg';

function PremiumBackButtonMonacofit(props: SVG) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={48}
      height={48}
      viewBox="0 0 48 48"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <defs>
        <path
          id="premium_back_button__a"
          d="M30.82 14.82L28 12 16 24l12 12 2.82-2.82L21.66 24z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="premium_back_button__b" fill="#fff">
          <use xlinkHref="#premium_back_button__a" />
        </mask>
        <g fill="#0081FF" mask="url(#premium_back_button__b)">
          <path d="M0 0h48v48H0z" />
        </g>
      </g>
    </svg>
  );
}

export default PremiumBackButtonMonacofit;
